import {WitcherValidationError} from "./WitcherValidationError";

export function isWitcherValidationError(o?: any): o is WitcherValidationError {
    return typeof o?.message === 'string'
}
